module.exports = __webpack_public_path__ + "static/media/regi_default.1b1ee5e0.svg";